import { NavLink } from "react-router";
import number_format from "../../utils/number_format";
import OpportunityRow from "./OpportunityRow";
import ThSorted from "../Table/ThSorted";
import CompanyDetailModal from "../modals/company/CompanyDetailModal";
import { useState } from "react";
import { useTranslation } from "../../hooks/useTranslation";

function OpportunityTable({
  awailableColumns,
  selectedColumns,
  opportunities,
  checkbox,
  sortTable,
  setSortTable,
}) {
  const { t } = useTranslation();
  const [companyId, setCompanyId] = useState(false);
  return (
    <>
      <CompanyDetailModal
        company_id={companyId}
        onHide={() => setCompanyId(false)}
      />
      <div
        id="kt_customers_table_wrapper"
        className="dt-container dt-bootstrap5 dt-empty-footer"
      >
        <div id="" className="xtable-responsive xsticky-table">
          <table
            className="table align-middle table-row-dashed fs-6 gy-5 dataTable"
            id="kt_customers_table"
            style={{ width: "100%" }}
          >
            <thead>
              <tr className="text-start fw-bold fs-7 text-uppercase gs-0">
                {false && checkbox !== false && (
                  <th
                    className="w-10px pe-2 dt-orderable-none"
                    data-dt-column="0"
                    rowSpan="1"
                    colSpan="1"
                  >
                    <span className="dt-column-title">
                      <div className="form-check form-check-sm form-check-custom form-check-solid me-3">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          data-kt-check="true"
                          data-kt-check-target="#kt_customers_table .form-check-input"
                          value="1"
                          onChange={(e) => console.log(e.target.value)}
                        />
                      </div>
                    </span>
                    <span className="dt-column-order"></span>
                  </th>
                )}
                {Object.keys(awailableColumns)
                  .filter((awailableColumnsKey) =>
                    selectedColumns.includes(awailableColumnsKey)
                  )
                  .map((awailableColumnsKey, th_key) => (
                    <ThSorted
                      key={th_key}
                      awailableColumns={awailableColumns}
                      awailableColumnsKey={awailableColumnsKey}
                      sortTable={sortTable}
                      setSortTable={setSortTable}
                    />
                  ))}
                <th
                  className="min-w-150px dt-orderable-asc dt-orderable-desc text-end"
                  data-dt-column="2"
                  rowSpan="1"
                  colSpan="1"
                  aria-label="Email: Activate to sort"
                  tabIndex="0"
                >
                  <span className="dt-column-title" role="button">
                    {t("common.actions")}
                  </span>
                  <span className="dt-column-order"></span>
                </th>
              </tr>
            </thead>
            <tbody className="fw-semibold text-gray-600">
              {opportunities?.data?.length > 0 &&
                opportunities.data?.map((opportunity, kopportunity) => (
                  <OpportunityRow
                    opportunity={opportunity}
                    awailableColumns={awailableColumns}
                    selectedColumns={selectedColumns}
                    checkbox={checkbox}
                    key={kopportunity}
                    showCompanyDetail={(company_id) => setCompanyId(company_id)}
                  />
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default OpportunityTable;
